export default "__VITE_ASSET__b039d5c1__"